import React, { useContext, useMemo, useState } from "react";
import TriggerNodeTemplate from "../templates/TriggerNodeTemplate";
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import NodeConfigModal from "../../menus/NodeConfigModal";
import ExternalApiDocsContent from "../../menus/ExternalApiDocsContent";
import AddNodeContext from "../../../../contexts/AddNodeContext";
import { useParams } from "react-router-dom";

export default function ExternalApiNode({ id, type, data }) {
  const [isDocsOpen, setIsDocsOpen] = useState(false);
  const { flowId } = useContext(AddNodeContext);
  const { brandId } = useParams();
  const description =
    (data?.description || "").trim() || "Triggered only by external API";
  const externalFields = useMemo(
    () => (Array.isArray(data?.externalFields) ? data.externalFields : []),
    [data?.externalFields]
  );

  const docsButton = (
    <Tooltip title="API guide" placement="top">
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          setIsDocsOpen(true);
        }}
      >
        <InfoOutlinedIcon sx={{ color: "#aaa", fontSize: 10 }} />
      </IconButton>
    </Tooltip>
  );

  const handleDocsModalClose = () => {
    setIsDocsOpen(false);
  };

  return (
    <>
      <TriggerNodeTemplate id={id} type={type} data={data} headerActions={docsButton}>
        <Tooltip title={description} placement="top">
          <Typography
            fontSize={8}
            noWrap
            dir="auto"
            sx={{ width: "100%", textAlign: "start" }}
          >
            {description}
          </Typography>
        </Tooltip>
      </TriggerNodeTemplate>

      <NodeConfigModal
        open={isDocsOpen}
        onClose={handleDocsModalClose}
      >
        <Box
          sx={{
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            bgcolor: "#2C2B2D",
            color: "#FFFFFF",
          }}
        >
          <Box
            sx={{
              flexShrink: 0,
              bgcolor: "#1E1E1E",
              color: "#0DA3E2",
              fontFamily: "Assistant, sans-serif",
              fontWeight: 600,
              fontSize: "28px",
              lineHeight: 1,
              px: "28px",
              py: "16px",
              borderBottom: "1px solid rgba(173, 180, 189, 0.2)",
            }}
          >
            External API Guide
          </Box>

          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              minHeight: 0,
              p: "30px 32px 12px 32px",
            }}
          >
            <ExternalApiDocsContent
              externalFields={externalFields}
              flowId={flowId}
              brandId={brandId}
            />
          </Box>

          <Box
            sx={{
              flexShrink: 0,
              mt: "auto",
              pb: "24px",
              px: "32px",
              bgcolor: "#2C2B2D",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => setIsDocsOpen(false)}
              sx={{
                width: "187px",
                height: "50px",
                minWidth: "187px",
                borderRadius: "7px",
                borderColor: "#0DA3E2",
                color: "#FFFFFF",
                px: "10px",
                py: "10px",
                gap: "10px",
                textTransform: "none",
                "&:hover": {
                  borderColor: "#0DA3E2",
                  bgcolor: "rgba(13, 163, 226, 0.08)",
                },
              }}
            >
              <Typography color="#FFFFFF" fontWeight={700} fontSize="20px" lineHeight={1}>
                Close
              </Typography>
            </Button>
          </Box>
        </Box>
      </NodeConfigModal>
    </>
  );
}
